import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OpsInputComponent } from '../ops-input/ops-input.component';
import { NgxsModule } from '@ngxs/store';
import { SettingsEditState } from '@ops/services';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { OpsSecuritySettingsComponent } from './ops-security-settings.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    OpsInputComponent,
    NgxsModule.forRoot([SettingsEditState]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    TranslateModule,
  ],
  declarations: [OpsSecuritySettingsComponent],
  exports: [OpsSecuritySettingsComponent],
})
export class OpsSecuritySettingsModule {}
